<div
  class="form-group  {{
    control && !!control.invalid ? 'fg-invalid' : 'fg-valid'
  }} {{ required ? 'fg-required' : '' }} {{ settings.class }}"
  *ngIf="settings"
>
  <label for="input-{{ settings.fieldName | titlecase }}">
    {{ settings.label }}
    <span
      *ngIf="required && !disabled && !settings.disableAsterisk"
      class="text-danger required-asterisk-sign"
      >*</span
    >
  </label>
  <div
    [ngClass]="{
      'd-flex input-group': true
    }"
    [class]="settings.customInputClass"
  >
    <input
      class="form-control {{
        control && !!control.invalid ? 'ng-invalid' : 'ng-valid'
      }} {{ required ? 'required' : '' }}
      {{ disabled ? 'input-only' : '' }}
      {{ data && settings?.showFieldHasValue === true ? 'filled-out' : '' }}"
      name="dp"
      bsDatepicker
      #d="bsDatepicker"
      [bsValue]="data"
      [placeholder]="settings.placeholder || 'dd-mm-yyyy'"
      [disabled]="disabled"
      [required]="required"
      [bsConfig]="bsConfig"
      (bsValueChange)="datepickerChanged($event)"
    />
    <rr-info-icon
      *ngIf="settings.showInfoIcon"
      [className]="iconClassName"
      [tooltipText]="settings.infoIconTooltip"
    ></rr-info-icon>
    <div class="input-group-append">
      <button
        *ngIf="!settings.hidecalendarButton && !disabled"
        type="button"
        class="btn btn-outline-secondary btn-calendar input-group-text"
        [disabled]="disabled"
        (click)="d.toggle()"
      >
        <span class="oi oi-calendar"></span>
      </button>
      <button
        class="date-input-clear input-group-text"
        type="button"
        *ngIf="!settings.hideResetInput && !disabled"
        tabindex="-1"
        [disabled]="disabled"
        (click)="onClearInput()"
      >
        <span class="clear-text" style="display: none">Clear</span>
        <span class="oi oi-x"></span>
      </button>
    </div>
  </div>
  <div class="error-message" *ngIf="showError">
    {{ errors[0] }}
  </div>
</div>
